export const INTERNAL_ERROR_PATH = '/error';
export const PSX_BLUE_GREEN_CANARY_SESSION_STORAGE_KEY =
  'psxBlueGreenCanaryColor';
